<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-row>
            <v-col cols="12">
              <v-alert v-model="alertSuccessFlg" type="success" density="compact" :title=successMsg closable
                class="ma-2" />
              <v-alert v-model="alertErrorFlg" type="error" density="compact" :title=errorMsg closable class="ma-2" />
            </v-col>
          </v-row>
          <v-row v-for="uploadType in UPLOAD_TYPES" :key=uploadType>
            <v-col cols="6">
              {{ $t(`cooperationFileUpload.label.${uploadType}`) }}
              <v-btn dark class="ml-4 bg-indigo-darken-1" :disabled="isLoading" elevation="2" :loading="isLoading"
                @click="onUpdateBtnClick(uploadType)">
                {{ $t('common.action.upload') }}
              </v-btn>
              <v-btn v-if="uploadType == 'productMasterFile'" dark class="ml-4 bg-indigo-darken-1" :disabled="isLoading"
                elevation="2" :loading="isLoading" @click="exportProduct">
                {{ $t('common.action.download') }}
              </v-btn>
            </v-col>
          </v-row>
          <!-- 売却済み資産ファイル（管理者のみ） -->
          <v-row v-if="isAdmin()">
            <v-col cols="12">
              {{ $t('cooperationFileUpload.label.soldAssetFile') }}
              <v-btn id="soldAssetUploadBtn" dark class="ml-4 bg-indigo-darken-1" :disabled="isSoldAssetLoading || isSoldAssetResultLoading" elevation="2"
                :loading="isSoldAssetLoading" @click="onUpdateBtnClick('soldAssetFile')">
                {{ $t('common.action.upload') }}
              </v-btn>
              <a id="soldAssetSampleLink" href="#" class="ml-4" @click.prevent="downloadSoldAssetSample">
                {{ $t('cooperationFileUpload.action.downloadSoldAssetSample') }}</a>
              <span id="soldAssetLastImport" class="ml-4">
                {{ $t('cooperationFileUpload.label.lastImportDatetime') }}：{{ lastSoldAssetImportDatetime }}</span>
              <div class="text-caption mt-1" style="white-space: pre-line">{{ $t('cooperationFileUpload.message.soldAssetDescription') }}</div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              {{ $t(`cooperationFileUpload.label.resultList`) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-table density="compact" class="text-no-wrap">
                <thead>
                  <tr>
                    <th v-for="header in headers" :key="header">
                      {{ $t("cooperationFileUpload.label.table." + header) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in sortedTable" :key="data.id">
                    <td v-for="header in headers" :key="header">{{ data[header] }}</td>
                  </tr>
                  <tr>
                    <td :colspan="headers.length"></td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>

          <!-- 売却済み資産ファイル 取込履歴（管理者のみ） -->
          <template v-if="isAdmin()">
            <v-row>
              <v-col cols="6">
                {{ $t('cooperationFileUpload.label.soldAssetHistory') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-table id="soldAssetHistoryTable" density="compact" class="text-no-wrap">
                  <thead>
                    <tr>
                      <th v-for="header in soldAssetHistoryHeaders" :key="header">
                        {{ $t("cooperationFileUpload.label.soldAssetTable." + header) }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in soldAssetHistoryTable" :key="data.importId">
                      <td v-for="header in soldAssetHistoryHeaders" :key="header">{{ data[header] }}</td>
                      <td>
                        <v-btn size="small" class="bg-indigo-darken-1" :disabled="isSoldAssetLoading || isSoldAssetResultLoading"
                          @click="openSoldAssetResult(data.importId)">
                          {{ $t('cooperationFileUpload.action.showResult') }}
                        </v-btn>
                      </td>
                    </tr>
                    <tr>
                      <td :colspan="soldAssetHistoryHeaders.length + 1"></td>
                    </tr>
                  </tbody>
                </v-table>
              </v-col>
            </v-row>
          </template>

        </v-container>
        <input ref="updateBtn" type="file" accept=".csv,.dat" style="display: none" @change="selectedFile" />
        <ConfirmDialog v-if="confirmDialogVisible" :dialog-data="confirmDialog" :handle-ok="upload"
          :handle-cancel="closeConfirmDialog" />
        <SoldAssetResultDialog v-if="soldAssetResultVisible" :dialog-data="soldAssetResultDialog"
          :handle-close="closeSoldAssetResult" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>
<script lang="js">
import AppWrapperView from "@/components/views/AppWrapperView";
import api from "@/apis/staff";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
import SoldAssetResultDialog from "@/components/dialog/SoldAssetResultDialog";
import utils from "@/utils";
import store from "@/store";
import constant from "@/utils/constant";

export default {
  components: { AppWrapperView, ConfirmDialog, SoldAssetResultDialog },
  props: {},
  computed: {
    headers() {
      return this.$getTableDef("CooperationFileUpload");
    },
    sortedTable() {
      let tempArray = this.dataList.map(x => x);
      tempArray = tempArray.map((x) => {
        x.execDatetime = utils.putSplitWordToCalendarWithTime(x.execDatetime);
        return x;
      });
      return tempArray;
    },
    soldAssetHistoryHeaders() {
      return this.$getTableDef("SoldAssetImportHistory");
    },
    // 最終取込日時（取込履歴の最新）
    lastSoldAssetImportDatetime() {
      return this.soldAssetHistoryTable[0]?.execDatetime ?? "－";
    },
    soldAssetHistoryTable() {
      return this.soldAssetHistoryList.map((x) => ({
        ...x,
        execDatetime: utils.putSplitWordToCalendarWithTime(x.execDatetime),
        user: x.userName ? `${x.userId} ${x.userName}` : x.userId,
      }));
    },
  },
  data: () => ({
    UPLOAD_TYPES: ["productMasterFile"],
    // 確認ダイアログ
    confirmDialogVisible: false,
    confirmDialog: {
      message: null,
    },
    // アップロード情報
    uploadType: null,
    uploadFile: null,
    // メッセージ関連
    alertSuccessFlg: false,
    alertErrorFlg: false,
    successMsg: "",
    errorMsg: "",
    isLoading: false,
    dataList: [],
    // 売却済み資産ファイル
    soldAssetHistoryList: [],
    // 売却済み資産ファイルの取込中（このボタンだけをローディング表示にする）
    isSoldAssetLoading: false,
    // 取込履歴の結果を取得中（ローディング表示はせず、操作のみ止める）
    isSoldAssetResultLoading: false,
    soldAssetResultVisible: false,
    soldAssetResultDialog: {
      result: null,
    },
  }),
  methods: {
    // アップロードボタン押下
    onUpdateBtnClick(type) {
      this.resetMsg();
      this.uploadType = type;
      this.$refs.updateBtn.value = null;
      this.$refs.updateBtn.click();
    },
    // ファイル選択後に確認ダイアログを表示
    selectedFile() {
      this.uploadFile = this.$refs.updateBtn.files[0];

      const fileName = this.uploadFile.name;
      const typeName = this.$t(`cooperationFileUpload.label.${this.uploadType}`);
      const message = this.$t(`cooperationFileUpload.message.confirm`, [typeName, fileName]);

      this.confirmDialog.message = message;
      this.confirmDialogVisible = true;
    },
    // ダイアログ非表示
    closeConfirmDialog() {
      this.confirmDialogVisible = false;
      this.confirmDialog.file = null;
    },
    // メッセージ初期化
    resetMsg() {
      this.alertSuccessFlg = false;
      this.alertErrorFlg = false;
      this.successMsg = "";
      this.errorMsg = "";
    },
    // 管理者か
    isAdmin() {
      return store.getRole() == constant.ROLE.ADMIN.id;
    },
    // アップロード
    upload() {
      if (this.uploadType == 'soldAssetFile') {
        this.uploadSoldAsset();
        return;
      }
      this.isLoading = true;
      this.resetMsg();
      this.closeConfirmDialog();

      let formData = new FormData();
      formData.append("file", this.uploadFile);
      formData.append("uploadType", this.uploadType);

      api.postFile("/cooperation-file/upload", formData)
        .then((response) => {
          if (response.data?.status == 0) {
            this.successMsg = this.$t('cooperationFileUpload.message.complete');
            this.alertSuccessFlg = true;
          } else {
            this.errorMsg = response.data?.errorMessage;
            this.alertErrorFlg = true;
          }
        })
        .catch(() => {
          this.errorMsg = this.$t('common.message.unknownError');
          this.alertErrorFlg = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    exportProduct() {
      this.isLoading = true;
      this.resetMsg();
      api.postWithConfig(
        "/product/download-master", {}, { responseType: 'blob' }
      )
        .then(async response => {
          // 失敗時はJSONでエラー内容が返却される
          if (response.data.type == "application/json") {
            const errText = await response.data.text()
            const json = JSON.parse(errText);
            this.errorMsg = json.errorMessage;
            this.alertErrorFlg = true;
            return;
          }
          const blob = new Blob([response.data], { type: 'application/zip' });
          const url = URL.createObjectURL(blob);
          const fileName = this.$t('cooperationFileUpload.fileNamePrefix.exportProduct');
          const timestamp = utils.csvTimeStamp(new Date());

          const link = document.createElement("a");
          link.href = url;
          link.download = `${fileName}${timestamp}.zip`;
          link.click();
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.errorMsg = this.$t('common.message.unknownError');
          this.alertErrorFlg = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 売却済み資産ファイル取込（APIで取り込み、結果をダイアログに表示）
    uploadSoldAsset() {
      this.isSoldAssetLoading = true;
      this.resetMsg();
      this.closeConfirmDialog();

      let formData = new FormData();
      formData.append("file", this.uploadFile);

      api.postFile("/cooperation-file/sold-asset/upload", formData)
        .then((response) => {
          if (response.data?.status == 0) {
            this.showSoldAssetResult(response.data.results);
            this.fetchSoldAssetHistory();
          } else {
            const details = (response.data?.errorList ?? []).map(e => e.message);
            this.errorMsg = [response.data?.errorMessage, ...details].filter(Boolean).join(" ");
            this.alertErrorFlg = true;
          }
        })
        .catch(() => {
          this.errorMsg = this.$t('common.message.unknownError');
          this.alertErrorFlg = true;
        })
        .finally(() => {
          this.isSoldAssetLoading = false;
        });
    },
    // 売却済み資産ファイルの取込フォーマット見本（見出し行＋記入例）をダウンロード
    // 記入例のJANは商品マスタに存在しない値（見本をそのまま取り込んでも資産は移動しない）
    downloadSoldAssetSample() {
      const header = this.$t('cooperationFileUpload.label.soldAssetSampleHeader');
      const prefix = this.$t('cooperationFileUpload.fileNamePrefix.soldAssetSample');
      const sampleJanList = ["4999999999991", "4999999999992", "4999999999993"];
      utils.csvDownload([header, ...sampleJanList].join("\r\n") + "\r\n", `${prefix}${utils.csvTimeStamp(new Date())}`);
    },
    // 売却済み資産ファイル取込履歴取得
    fetchSoldAssetHistory() {
      if (!this.isAdmin()) return;
      api.post("/cooperation-file/sold-asset/history/search", {})
        .then((response) => {
          if (response.data?.status == 0) {
            this.soldAssetHistoryList = response.data.results?.historyList ?? [];
          } else {
            this.errorMsg = response.data?.errorMessage;
            this.alertErrorFlg = true;
          }
        })
        .catch(() => {
          this.errorMsg = this.$t('common.message.unknownError');
          this.alertErrorFlg = true;
        });
    },
    // 取込履歴から結果を再表示
    openSoldAssetResult(importId) {
      this.isSoldAssetResultLoading = true;
      this.resetMsg();
      api.post("/cooperation-file/sold-asset/history/detail", { importId })
        .then((response) => {
          if (response.data?.status == 0) {
            this.showSoldAssetResult(response.data.results);
          } else {
            this.errorMsg = response.data?.errorMessage;
            this.alertErrorFlg = true;
          }
        })
        .catch(() => {
          this.errorMsg = this.$t('common.message.unknownError');
          this.alertErrorFlg = true;
        })
        .finally(() => {
          this.isSoldAssetResultLoading = false;
        });
    },
    showSoldAssetResult(result) {
      this.soldAssetResultDialog.result = result;
      this.soldAssetResultVisible = true;
    },
    closeSoldAssetResult() {
      this.soldAssetResultVisible = false;
      this.soldAssetResultDialog.result = null;
    },
    // 取込実績取得
    fetchCollaborationResult() {
      api.post("/cooperation-file/collaboration-result/search", {})
        .then((response) => {
          if (response.data?.status == 0) {
            this.dataList = response.data.results?.resultList ?? [];
          } else {
            this.errorMsg = response.data?.errorMessage;
            this.alertErrorFlg = true;
          }
        })
        .catch(() => {
          this.errorMsg = this.$t('common.message.unknownError');
          this.alertErrorFlg = true;
        });
    },
  },
  mounted() {
    this.fetchCollaborationResult();
    this.fetchSoldAssetHistory();
  },
};
</script>
